/**
 * JS->Android(専用)
 * Nativeアプリと連携する用のインターフェース
 */
export interface JavaScriptInterface {
    // デバイスを探す
    scanDevices(): void;
    // SharedPreferencesに値を保存する
    setItem(key: string, value: string): void;
    // SharedPreferencesから値を取得する
    getItem(key: string): string | null;
    // SharedPreferencesから値を削除する
    removeItem(key: string): void;
    // SharedPreferencesを全てクリアする
    clear(): void;
}

/**
 * SharedPreferencesに保存するキー定数
 */
export const NATIVE_STORE_KEY = {
    // アクセストークン
    AccessToken: 'accessToken',
} as const;

/**
 * iOS/Android->JS
 * Nativeアプリから値を受け取るイベン名
 */
export enum EventName {
    // デバイス情報
    DeviceInfos = 'deviceInfo',
}